import { companyContactFragment } from './fragments/companyContacts';

export const updateCompanyContactMutation = `
  mutation UpdateCompanyContact(
    $input: UpdateCompanyContactInput!
    $withAffordability: Boolean! = true
  ) {
    item: updateCompanyContact(input: $input) {
      ${companyContactFragment}
    }
  }
`;

export const deleteCompanyContactMutation = `
  mutation DeleteCompanyContact(
    $id: Int!
    $withAffordability: Boolean! = true
  ) {
    item: deleteCompanyContact(id: $id) {
      ${companyContactFragment}
    }
  }
`;
